export default __webpack_public_path__ + "static/media/arrow-up.f12d980f.svg";